import { useShared } from '@othercommerce/foundation';
import { computed } from 'vue';

export function usePageEditing() {
  const shared = useShared();

  return computed(() => shared.value.editing);
}
